const SOCKET_EVENT_LOGIN_REQUEST = 'login_request';
const SOCKET_EVENT_LOGIN_RESPONSE = 'login_response';
const SOCKET_EVENT_REMOVE_NEW_REQUEST = 'remove_new_request';
const SOCKET_EVENT_REMOVE_NEW_RESPONSE = 'remove_new_response';
const SOCKET_EVENT_SET_FAVORITE_REQUEST = 'set_favorite_request';
const SOCKET_EVENT_SET_FAVORITE_RESPONSE = 'set_favorite_response';
const SOCKET_EVENT_SET_LIKE_REQUEST = 'set_like_request';
const SOCKET_EVENT_SET_LIKE_RESPONSE = 'set_like_response';
const SOCKET_EVENT_SET_LIKE_COMMENT_REQUEST = 'set_like_comment_request';
const SOCKET_EVENT_SET_LIKE_COMMENT_RESPONSE = 'set_like_comment_response';
const SOCKET_EVENT_RATE_DOCUMENT_REQUEST = 'rate_document_request';
const SOCKET_EVENT_RATE_DOCUMENT_RESPONSE = 'rate_document_response';
const SOCKET_EVENT_ADD_COMMENT_REQUEST = 'add_comment_request';
const SOCKET_EVENT_ADD_COMMENT_RESPONSE = 'add_comment_response';
const SOCKET_EVENT_EDIT_COMMENT_REQUEST = 'edit_comment_request'
const SOCKET_EVENT_EDIT_COMMENT_RESPONSE = 'edit_comment_response'
const SOCKET_EVENT_REMOVE_COMMENT_REQUEST = 'remove_comment_request'
const SOCKET_EVENT_REMOVE_COMMENT_RESPONSE = 'remove_comment_response'
const SOCKET_EVENT_DISCONNECT = 'disconnect';
const SOCKET_EVENT_KNOWLEDGE_LIST_REQUEST = 'knowledge_list_request';
const SOCKET_EVENT_KNOWLEDGE_LIST_RESPONSE = 'knowledge_list_response';
const SOCKET_EVENT_SEND_MESSAGE_REQUEST = 'send_message_request';
const SOCKET_EVENT_SEND_MESSAGE_RESPONSE = 'send_message_response_v2';
const SOCKET_EVENT_NOTIFY_MESSAGE_RECEIVED_REQUEST = 'notify_message_received';
const SOCKET_EVENT_CHANGE_ROOM_STATUS_REQUEST = 'change_room_status_request';
const SOCKET_EVENT_SET_CHAT_POINTER_REQUEST = 'set_chat_pointer_request';
const SOCKET_EVENT_NOTIFY_UPDATED_ROOM = 'notify_updated_room';
const SOCKET_EVENT_BIND_EDITOR_CLIENT_REQUEST = 'bind_editor_client';
const SOCKET_EVENT_BIND_EDITOR_CLIENT_RESPONSE = 'bind_editor_response';
const SOCKET_EVENT_EDITOR_STATUS_UPDATED = 'editor_status_updated';
const SOCKET_EVENT_EDITOR_CONTENT_REQUEST = 'editor_content_request';
const SOCKET_EVENT_EDITOR_CONTENT_RESPONSE = 'editor_content_response';
const SOCKET_EVENT_EDITOR_SEND_IMAGE_REQUEST = 'editor_send_image';
const SOCKET_EVENT_EDITOR_SEND_EXTERNAL_CONTENT = 'editor_send_external_content';
const SOCKET_EVENT_EDITOR_CANCEL_OPERATION = 'editor_cancel_operation';

class SocketEvents{
    static LOGIN_REQUEST() { return SOCKET_EVENT_LOGIN_REQUEST; }
    static LOGIN_RESPONSE() { return SOCKET_EVENT_LOGIN_RESPONSE; }
    static REMOVE_NEW_REQUEST() { return SOCKET_EVENT_REMOVE_NEW_REQUEST; }
    static REMOVE_NEW_RESPONSE() { return SOCKET_EVENT_REMOVE_NEW_RESPONSE; }
    static SET_FAVORITE_REQUEST() { return SOCKET_EVENT_SET_FAVORITE_REQUEST; }
    static SET_FAVORITE_RESPONSE() { return SOCKET_EVENT_SET_FAVORITE_RESPONSE; }
    static SET_LIKE_REQUEST() { return SOCKET_EVENT_SET_LIKE_REQUEST; }
    static SET_LIKE_RESPONSE() { return SOCKET_EVENT_SET_LIKE_RESPONSE; }
    static SET_LIKE_COMMENT_REQUEST() { return SOCKET_EVENT_SET_LIKE_COMMENT_REQUEST; }
    static SET_LIKE_COMMENT_RESPONSE() { return SOCKET_EVENT_SET_LIKE_COMMENT_RESPONSE; }
    static RATE_DOCUMENT_REQUEST() { return SOCKET_EVENT_RATE_DOCUMENT_REQUEST; }
    static RATE_DOCUMENT_RESPONSE() { return SOCKET_EVENT_RATE_DOCUMENT_RESPONSE; }
    static ADD_COMMENT_REQUEST() { return SOCKET_EVENT_ADD_COMMENT_REQUEST; }
    static ADD_COMMENT_RESPONSE() { return SOCKET_EVENT_ADD_COMMENT_RESPONSE; }
    static EDIT_COMMENT_REQUEST() { return SOCKET_EVENT_EDIT_COMMENT_REQUEST; }
    static EDIT_COMMENT_RESPONSE() { return SOCKET_EVENT_EDIT_COMMENT_RESPONSE; }
    static REMOVE_COMMENT_REQUEST() { return SOCKET_EVENT_REMOVE_COMMENT_REQUEST; }
    static REMOVE_COMMENT_RESPONSE() { return SOCKET_EVENT_REMOVE_COMMENT_RESPONSE; }
    static DISCONNECT() { return SOCKET_EVENT_DISCONNECT; }
    static KNOWLEDGE_LIST_REQUEST() { return SOCKET_EVENT_KNOWLEDGE_LIST_REQUEST; }
    static KNOWLEDGE_LIST_RESPONSE() { return SOCKET_EVENT_KNOWLEDGE_LIST_RESPONSE; }
    static SEND_MESSAGE_REQUEST() { return SOCKET_EVENT_SEND_MESSAGE_REQUEST; }
    static SEND_MESSAGE_RESPONSE() { return SOCKET_EVENT_SEND_MESSAGE_RESPONSE; }
    static NOTIFY_MESSAGE_RECEIVED_REQUEST() { return SOCKET_EVENT_NOTIFY_MESSAGE_RECEIVED_REQUEST; }
    static CHANGE_ROOM_STATUS_REQUEST() { return SOCKET_EVENT_CHANGE_ROOM_STATUS_REQUEST; }
    static SET_CHAT_POINTER_REQUEST() { return SOCKET_EVENT_SET_CHAT_POINTER_REQUEST; }
    static NOTIFY_UPDATED_ROOM() { return SOCKET_EVENT_NOTIFY_UPDATED_ROOM; }
    static BIND_EDITOR_CLIENT_REQUEST() { return SOCKET_EVENT_BIND_EDITOR_CLIENT_REQUEST; }
    static BIND_EDITOR_CLIENT_RESPONSE() { return SOCKET_EVENT_BIND_EDITOR_CLIENT_RESPONSE; }
    static EDITOR_STATUS_UPDATED() { return SOCKET_EVENT_EDITOR_STATUS_UPDATED; }
    static EDITOR_CONTENT_REQUEST() { return SOCKET_EVENT_EDITOR_CONTENT_REQUEST; }
    static EDITOR_CONTENT_RESPONSE() { return SOCKET_EVENT_EDITOR_CONTENT_RESPONSE; }
    static EDITOR_SEND_IMAGE() { return SOCKET_EVENT_EDITOR_SEND_IMAGE_REQUEST; }
    static EDITOR_SEND_EXTERNAL_CONTENT() { return SOCKET_EVENT_EDITOR_SEND_EXTERNAL_CONTENT; }
    static EDITOR_CANCEL_OPERATION() { return SOCKET_EVENT_EDITOR_CANCEL_OPERATION; }
}
